var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "purchase-block mt-30 f-column-b" }, [
    _c("div", { staticClass: "purchase-block-header f-b-c" }, [
      _c("h4", { class: _vm.projectType }, [
        _vm._v(_vm._s(_vm.projTypeItem[_vm.label])),
      ]),
      _c(
        "ul",
        { staticClass: "f-start-c flex-1 ml-20" },
        _vm._l(_vm.noticeTypeList, function (nt) {
          return _c(
            "li",
            {
              key: nt[_vm.code],
              staticClass: "fc33 mr-20",
              class: { active: nt[_vm.code] === _vm.noticeType },
              on: {
                click: function ($event) {
                  return _vm.changeNoticeType(nt[_vm.code])
                },
              },
            },
            [_vm._v(_vm._s(nt[_vm.label]))]
          )
        }),
        0
      ),
      _c(
        "a",
        {
          staticClass: "a-btn",
          attrs: { href: _vm.moreBtnUrl, target: "_blank" },
        },
        [_vm._v("更多 >")]
      ),
    ]),
    _c(
      "div",
      { staticClass: "list mt-20" },
      [
        _vm.list.length
          ? _c(
              "el-table",
              {
                staticClass: "project-table",
                attrs: {
                  height: "100%",
                  data: _vm.list,
                  fit: "",
                  "default-sort": { prop: "endTime", order: null },
                  "header-cell-style": _vm.headerCellStyle,
                  "cell-style": _vm.cellStyle,
                },
                on: {
                  "sort-change": _vm.handleSortChange,
                  "row-click": _vm.rowClick,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { label: "项目名称", "min-width": "180" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              {
                                staticClass: "text-cut",
                                attrs: { title: scope.row.gonggaoTitle },
                              },
                              [_vm._v(_vm._s(scope.row.gonggaoTitle))]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    3797241240
                  ),
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "purchaseWayName",
                    label: "采购方式",
                    width: "150",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    prop: "endTime",
                    label: "截止时间",
                    sortable: "custom",
                    width: "180",
                  },
                }),
                _c("el-table-column", {
                  attrs: { label: "状态", width: "120" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "table-btn",
                                style: {
                                  backgroundColor: ["1", "3"].includes(
                                    scope.row.status
                                  )
                                    ? "#DC4B19"
                                    : "#999",
                                },
                              },
                              [_vm._v(_vm._s(scope.row.status_name))]
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1616409830
                  ),
                }),
              ],
              1
            )
          : _c("no-data", { attrs: { "no-txt": "" } }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }